import React from 'react';
import styled from 'styled-components';
import { layout, media, colors } from '@prisjakt/ui-base';
import { Column } from '@prisjakt/ui/list/variants';
import ToggleButton from '../toggle-button';
import { applyFilterAreaHeight } from 'src/components/filter-overlay/constants';
import { zindex } from 'src/ui/zindex';

export const Wrapper = styled.section`
  padding: 0 ${layout.measurements.spacing050};
  margin-bottom: ${layout.measurements.spacing100};
`;

export const Filter = styled.div`
  background: ${colors.backgroundDarkGray};
  min-height: 100%;
  /* To make the background color cover the all sidebar
    we remove the sidebar padding by adding a negative margin
  */
  margin: -${layout.measurements.spacing050};
  font-size: 12px;
`;

export const FilterTitle = styled.h2`
  font-size: ${layout.measurements.fontSizeNormal};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin: 0;
  padding: ${layout.measurements.spacing100};
  padding-bottom: 0;
`;

export const FilterSearchWrapper = styled.div`
  padding: ${layout.measurements.spacing100};
`;

export const Group = styled.li`
  list-style: none;
`;

export const GroupTitle = styled.h3`
  font-size: ${layout.measurements.fontSizeNormal};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const NoContent = styled.div`
  border-radius: ${layout.borderRadius};
  background: ${p => p.theme.bg.secondary};
  padding: ${layout.measurements.spacing100} ${layout.measurements.spacing050};
  margin: ${layout.measurements.spacing025} 0;
  text-align: center;
`;

export const SectionSeparator = styled.li.attrs({ role: 'presentation' })`
  border-bottom: 1px solid ${colors.borderLightGray};
`;

export const SectionList = styled(Column).attrs({
  styledComponentProps: { as: 'ul' },
  separator: <SectionSeparator />,
})`
  list-style: none;
  width: 100%;
`;

type SectionListItemProps = {
  noPadding?: boolean;
};

export const SectionListItem = styled.li<SectionListItemProps>`
  padding-bottom: ${p => (p.noPadding ? '0' : layout.measurements.spacing100)};
  /* @TODO: No padding on SidebarContent? */
`;

export const MobileFilterDialog = styled.div`
  min-width: 0;
  flex: 1 1 0;
  background: ${p => p.theme.bg.primary};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${zindex.menu.filter};
  overflow-x: hidden;
  overflow-y: scroll; /* has to be scroll, not auto */
  -webkit-overflow-scrolling: touch;
  /* Makes sure no content is hidden behind the "apply filter" area */
  ::after {
    content: '';
    display: block;
    height: ${applyFilterAreaHeight}px;
  }
`;

export const MobileFilterHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const FilterSectionButtonList = styled.div`
  padding: 0 ${layout.measurements.spacing050};
  width: 100%;
`;

export const MobileSectionSeparator = styled(SectionSeparator).attrs({
  as: 'div',
})``;

export const MobileSectionList = styled(SectionList).attrs({
  styledComponentProps: { as: 'div' },
  separator: <MobileSectionSeparator />,
})`
  width: 100%;
`;

export const MobileToggleButton = styled(ToggleButton)`
  display: none;

  ${media.mediumDown`
    display: block;
  `}
`;
